<template>
    <div class="member min-height">
        <div class="flex align-center justify-between">
            <el-row :gutter="20">
                <el-col :span="6" class="search-some">
                    <span>企业名称：</span>
                    <el-input v-model="name" placeholder="请输入企业名称"></el-input>
                </el-col>
                <el-col :span="6" class="search-some">
                    <span>信用代码：</span>
                    <el-input v-model="code" placeholder="请输入信用代码"></el-input>
                </el-col>
                <el-col :span="6" class="search-some">
                    <span>会员类型：</span>
                    <el-select v-model="memberType" placeholder="请选择">
                        <el-option
                            v-for="item in memberTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="6" class="search-some">
                    <span>会员等级：</span>
                    <el-select v-model="level" placeholder="请选择">
                        <el-option
                            v-for="item in levelList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="6" class="search-some">
                    <span>到期时间：</span>
                    <el-date-picker
                        v-model="endTime"
                        class="flex-sub"
                        end-placeholder="结束日期"
                        range-separator="至"
                        start-placeholder="开始日期"
                        type="daterange"
                    >
                    </el-date-picker>
                </el-col>
                <el-col :span="18" class="search-some">
                    <div class="flex-shrink">服务类别(可多选)：</div>
                    <el-select v-model="moreType" multiple placeholder="请选择">
                        <el-option
                            v-for="item in memberType ===1 ? supply : memberType === 2 ? demand : []"
                            :key="item.value"
                            :label="item.label +'：'+ item.desc"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>

                <el-col :span="6" class="search-some">
                    <span>所在区域：</span>
                    <el-select v-model="address" placeholder="请选择">
                        <el-option
                            v-for="item in addressList"
                            :key="item.label"
                            :label="item.label"
                            :value="item.label"
                        >
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="6" class="search-some">
                    <span>注册地址：</span>
                    <el-input
                        v-model="registerAddress"
                        placeholder="请输入注册地址"
                    ></el-input>
                </el-col>
                <el-col :span="6" class="search-some">
                    <span>邮寄地址：</span>
                    <el-input
                        v-model="mailAddressDetail"
                        placeholder="请输入邮寄地址"
                    ></el-input>
                </el-col>
                <el-col :span="6" class="search-some">
                    <span>缴费状态：</span>
                    <el-select v-model="pay" placeholder="请选择">
                        <el-option
                            v-for="item in payList2"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-col>


                <el-col :span="6" class="search-some">
                    <span>证书编号：</span>
                    <el-input
                        v-model="certificate"
                        placeholder="请输入证书编号"
                    ></el-input>
                </el-col>
                <el-col :span="6" class="search-some">
                    <span>证书情况：</span>
                    <el-select v-model="apply" placeholder="请选择">
                        <el-option
                            v-for="item in applyList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="6" class="search-some">
                    <span>证书等级：</span>
                    <el-select v-model="search_dengji" placeholder="请选择">
                        <el-option
                            v-for="item in startList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="24">
                    <div class="flex align-center justify-end padding-bottom-sm">
                        <el-button
                            class="margin-left font-size"
                            type="primary"
                            @click="search"
                        >搜索
                        </el-button
                        >
                        <el-button
                            class="margin-left font-size"
                            type="primary"
                            @click="reset"
                        >重置
                        </el-button
                        >
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="flex align-center margin-bottom">
            <el-button
                v-if="user.user_role === 1"
                class="font-size"
                size="medium"
                type="primary"
                @click="toEdit"
            >
                <i class="margin-right-xs font-size el-icon-edit"></i>编辑
            </el-button>
            <el-button
                class="font-size"
                size="medium"
                type="primary"
                @click="toDetail"
            >
                <i class="margin-right-xs font-size el-icon-document"></i>查看详情
            </el-button>
<!--            TODO 在线缴费-->
            <el-button
                class="font-size"
                size="medium"
                type="primary"
                @click="toPayment"
            >
                <i class="margin-right-xs font-size el-icon-document"></i>缴费信息及发票管理
            </el-button>
            <el-button
                class="font-size"
                size="medium"
                type="primary"
                @click="toSureNoPay"
            >
                <i class="margin-right-xs font-size el-icon-document"></i>明确不续费
            </el-button>
            <el-button
                v-if="user.user_role !== 4"
                class="font-size"
                size="medium"
                type="primary"
                @click="certSet"
            >
                <i class="margin-right-xs font-size el-icon-plus"></i>证书制作
            </el-button>
            <el-button
                class="font-size"
                size="medium"
                type="primary"
                @click="certDetail"
            >
                <i class="margin-right-xs font-size el-icon-postcard"></i>证书详情
            </el-button>
            <el-button
                v-if="user.user_role === 1"
                class="font-size"
                size="medium"
                type="danger"
                @click="deleteItem"
            >
                <i class="margin-right-xs font-size el-icon-delete"></i>删除
            </el-button>
            <el-button
                v-if="user.user_role === 1"
                class="font-size"
                size="medium"
                type="danger"
                @click="resetItemAccount"
            >
                <i class="margin-right-xs font-size el-icon-refresh"></i>重置帐号
            </el-button>
            <el-button
                v-if="user.user_role === 1"
                class="font-size"
                size="medium"
                type="danger"
                @click="resetItem"
            >
                <i class="margin-right-xs font-size el-icon-refresh"></i>修改密码
            </el-button>
            <el-button
                v-if="user.user_role === 1"
                class="font-size"
                size="medium"
                type="danger"
                @click="resetItemPhone"
            >
                <i class="margin-right-xs font-size el-icon-refresh"></i>修改手机号
            </el-button>
            <!--            <el-button size="medium" type="warning" class="font-size" @click="smsItem">-->
            <!--                <i class="margin-right-xs font-size el-icon-position"></i>发送短信-->
            <!--            </el-button>-->

        </div>
        <div class="flex align-center margin-bottom">
            <el-button
                v-if="user.user_role !== 4"
                class="font-size"
                size="medium"
                type="warning"
                @click="setItemStatue"
            >
                <i class="margin-right-xs font-size el-icon-position"></i>证书已发放
            </el-button>
            <el-button
                v-if="user.user_role !== 4"
                class="font-size"
                size="medium"
                type="warning"
                @click="setItemExpress"
            >
                <i class="margin-right-xs font-size el-icon-position"></i>证书快递编号
            </el-button>
            <el-link
                v-if="user.user_role !== 4"
                :href="exportUrl"
                :underline="false"
                class="margin-left-xs"
                target="_blank"
            >
                <el-button class="font-size" size="medium" type="warning">
                    <i class="margin-right-xs font-size el-icon-upload2"></i>导出
                </el-button>
            </el-link>
        </div>
        <el-table
            ref="multipleTable"
            :data="tableData"
            alig="center"
            border
            header-row-class-name="table-header"
            row-class-name="table-row"
            style="width: 100%"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="序号" type="" width="80">
                <template slot-scope="scope">
                    {{ (page - 1) * 10 + scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column label="企业全称" prop="company_name" width="200px">
                <template slot-scope="scope">
                   <div :class="{del: scope.row.confirm_not_renew !== 0 }">
                       {{ scope.row.company_name }}
                   </div>
                </template>
            </el-table-column>
            <el-table-column
                label="社会统一信用代码"
                prop="company_code"
                width="200px"
            >
            </el-table-column>
            <el-table-column label="法人姓名" prop="legal_person_name" width="150px">
            </el-table-column>
            <el-table-column label="联系人" prop="tel_name" width="150px">
            </el-table-column>
            <el-table-column label="联系人电话" prop="tel_number" width="150px">
            </el-table-column>
            <el-table-column label="单位性质" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.company_type_id | type }}
                </template>
            </el-table-column>
            <el-table-column label="会员等级" prop="member_type" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.company_level_id | level }}
                </template>
            </el-table-column>
            <el-table-column label="供需分类" prop="member_type_text" width="150px">
            </el-table-column>
            <el-table-column label="证书情况" prop="state_text" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.state_text }}
                    <el-button
                        class="font-size-sm"
                        type="text"
                        @click="getAuditLog(scope.row.id)"
                    >
                        (审批记录)
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="缴费状态" prop="pay_style_text" width="150px">
            </el-table-column>

            <el-table-column label="证书编号" prop="cert_number" width="200px">
            </el-table-column>
            <el-table-column label="到期时间" prop="valid_time" width="200px">
            </el-table-column>
        </el-table>
        <div class="flex align-center justify-between padding-top-sm">
            <span>共{{ total }}条数据</span>
            <el-pagination
                v-if="tableData.length > 0"
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                layout="prev, pager, next, jumper"
                @current-change="getList"
            >
            </el-pagination>
        </div>

        <el-dialog
            v-if="multipleSelection.length > 0"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :title="multipleSelection[0].company_name + ' - 证书制作'"
            :visible.sync="dialog"
            center
            width="480px"
        >
            <el-form
                ref="certForm"
                :model="certForm"
                :rules="rules"
                label-width="150px"
            >
                <el-form-item label="缴费状态" prop="pay">
                    <el-select
                        v-model="certForm.pay"
                        placeholder="请选择缴费状态"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in payList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书编号" prop="number">
                    <el-input
                        v-model="certForm.number"
                        placeholder="请输入证书编号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="有效期开始时间" prop="start_time">
                    <el-date-picker
                        v-model="certForm.start_time"
                        placeholder="选择日期"
                        style="width: 100%"
                        type="date"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="有效期结束时间" prop="end_time">
                    <el-date-picker
                        v-model="certForm.end_time"
                        :picker-options="pickerOptions1"
                        placeholder="选择日期"
                        style="width: 100%"
                        type="date"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="服务类别及信用等级">
                    <div
                        v-for="(item, index) in server"
                        :key="index"
                        class="flex align-center justify-between"
                    >
                        <span>{{ item.name }}</span>
                        <el-select
                            v-model="server[index].start"
                            placeholder="请选择等级"
                            style="width: 150px"
                        >
                            <el-option
                                v-for="(item, x) in startList"
                                :key="x"
                                :label="item.label"
                                :value="item.label"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm('certForm')"
                    >取消
                    </el-button
                    >
                    <el-button
                        class="padding-lr-xl"
                        type="primary"
                        @click="submitForm('certForm')"
                    >提交
                    </el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog
            v-if="multipleSelection.length > 0"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :title="'短信模版选择'"
            :visible.sync="chioseMessage"
            center
            width="480px"
        >
            <el-form
                ref="smsForm"
                :model="smsForm"
                :rules="smsRules"
                label-width="80px"
            >
                <el-form-item label="短信类型" prop="pay">
                    <el-select
                        v-model="smsForm.type"
                        placeholder="请选择短信类型"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in chioseMessage"
                            :key="item.type"
                            :label="item.type"
                            :value="item.type"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm('certForm')"
                    >取消
                    </el-button
                    >
                    <el-button
                        class="padding-lr-xl"
                        type="primary"
                        @click="submitForm('certForm')"
                    >提交
                    </el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-drawer :visible.sync="drawer" :with-header="false" title="">
            <div class="padding">
                <el-timeline>
                    <el-timeline-item
                        v-for="(item, index) in list"
                        :key="index"
                        :timestamp="item.create_time"
                        placement="top"
                    >
                        <el-card v-if="item.state === 1">
                            <h4>新申请提交成功，经办人审核中</h4>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 3 || item.state === 12">
                            <h4>{{ item.renew === 1 ? '续费申请,' : '' }}审核人审核中</h4>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 5 || item.state === 14">
                            <h4>{{ item.renew === 1 ? '续费申请,' : '' }}审批人审核中</h4>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 2 || item.state === 11">
                            <h4>经办人驳回</h4>
                            <br/>
                            <p style="color: #9a0000">驳回原因：{{ item.message }}</p>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 4 || item.state === 13">
                            <h4>审核人驳回</h4>
                            <br/>
                            <p style="color: #9a0000">驳回原因：{{ item.message }}</p>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 6 || item.state === 15">
                            <h4>审批人驳回</h4>
                            <br/>
                            <p style="color: #9a0000">驳回原因：{{ item.message }}</p>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 7 || item.state === 17">
                            <h4>{{ item.renew === 1 ? '续费申请,' : '' }}信息审核通过，待缴费</h4>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 8 || item.state === 18">
                            <h4>待领取</h4>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 9 || item.state === 19">
                            <h4>已领取</h4>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 10">
                            <h4>信息提交成功，经办人审核中</h4>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 16">
                            <h4>审批通过，信息修改成功</h4>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-drawer>
    </div>
</template>

<script>

import {
    delMember,
    makeCert,
    resstusername,
    updatePass,
    updateStatus,
    userQuery,
    setExpressNumbers,
    setConfirmNotRenew
} from "@/api/admin";
import {
    address,
    applyList,
    demand,
    filesCN,
    level,
    memberType,
    nature,
    optionList,
    payList,
    supply,
    zhDate
} from '@/utils/utils'
import {UDHOST} from "@/config";
import {auditLog} from "@/api/member";

export default {
    name: "member",
    data() {
        return {
            supply: optionList(false, supply),
            demand: optionList(false, demand),
            pickerOptions1: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                }
            },
            name: '',
            code: '',
            certificate: '',
            search_dengji: '',
            apply: 0,
            memberType: 0,
            moreType: [],
            level: 0,
            address: '全部',
            pay: 0,
            registerAddress: '',
            mailAddressDetail: '',
            endTime: null,
            applyList: applyList,
            addressList: address,
            memberTypeList: memberType,
            levelList: level,
            page: 1,
            limit: 10,
            total: 0,
            tableData: [],
            multipleSelection: [],
            dialog: false,
            payList: optionList(false, payList),
            payList2: payList,

            startList: [
                {value: 1, label: 'A'},
                {value: 2, label: 'AA'},
                {value: 3, label: 'AAA'},
                {value: 4, label: 'AAAA'},
                {value: 5, label: 'AAAAA'}
            ],
            certForm: {
                pay: '',
                number: '',
                start_time: null,
                end_time: null,

            },
            server: [],
            rules: {
                pay: [{required: true, message: '请选择缴费状态', trigger: 'change'}],
                number: [{required: true, message: '请输入证书编号', trigger: 'blur'}],
                start_time: [{type: 'date', required: true, message: '请选择日期', trigger: 'change'}],
                end_time: [{type: 'date', required: true, message: '请选择日期', trigger: 'change'}]
            },
            chioseMessage: false,
            messageList: [
                {type: '缴费通知', info: '您的会员已到期，请登录续费'},
                {type: '领取通知', info: '请过来领证'},
            ],
            smsForm: {
                type: ''
            },
            smsRules: {
                type: [{required: true, message: '请选择短信模版', trigger: 'change'}],
            },
            drawer: false,
            list: [],
            exportUrl: '',
        }
    },
    created() {
        this.$emit("setIndex", this.$route.path, "会员管理  / ", false, 'icon-yonghu');
        this.getList()
        this.exportUrl = this.udhost + '/api/index/companyDataExport'
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        udhost() {
            return UDHOST
        },
    },
    components: {},

    methods: {
        async getAuditLog(id) {
            let _list = await auditLog(id)
            this.drawer = true
            this.list = _list.data
        },
        //  发送短信
        smsItem() {
            if (this.multipleSelection.length === 0) return this.$message.info('请选择至少一个会员')
            this.chioseMessage = true
        },
        //  已发放
        async setItemStatue() {
            if (this.multipleSelection.length === 0) return this.$message.info('请选择至少一个会员')
            let _arr = []
            this.multipleSelection.map(item => {
                _arr.push(item.id)
            })
            let _state = await updateStatus(_arr.join(','))
            if (_state.status === 200) {
                this.$message.success('操作成功')
            } else {
                this.$message.error(_state.msg)
            }
            this.getList()
            this.multipleSelection = []
        },
        //  已发放
        async setItemExpress() {
            if (this.multipleSelection.length > 1 || this.multipleSelection.length === 0) return this.$message.info('请选择一个会员操作')
            let _arr = []
            this.multipleSelection.map(item => {
                _arr.push(item.id)
            })
            this.$prompt('快递单号', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^\+?[A-Za-z0-9]*$/,
                inputErrorMessage: '请输入正确的快递单号'
            }).then(async({value}) => {
                let _state = await setExpressNumbers(_arr.join(','),value)
                if (_state.status === 200) {
                    this.$message.success('操作成功')
                } else {
                    this.$message.error(_state.msg)
                }
                this.getList()
                this.multipleSelection = []
            })

        },

        //  重置帐号
        async resetItemAccount() {
            if (this.multipleSelection.length > 1 || this.multipleSelection.length === 0) return this.$message.info('请选择一个会员操作')


            this.$confirm('此操作将重置改会员帐号为企业全称, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureResetAccount(this.multipleSelection[0].id, this.multipleSelection[0].company_name)
            })
        },
        async sureResetAccount(id, name) {
            let _state = await resstusername(id, name)
            if (_state.status === 200) {
                this.$message.success('操作成功')
            } else {
                this.$message.error(_state.msg)
            }
            this.getList()
            this.multipleSelection = []
        },
        //  重置密码
        async resetItem() {
            if (this.multipleSelection.length === 0) return this.$message.info('请选择至少一个会员')
            let _arr = []
            this.multipleSelection.map(item => {
                _arr.push(item.id)
            })
            this.$prompt('此操作将重置选择的会员密码, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                // inputErrorMessage: '邮箱格式不正确',
                type: 'warning'
            }).then(({value}) => {
                this.sureReset(_arr,value,'')
            })
        },
        //  重置手机号
        async resetItemPhone() {
            if (this.multipleSelection.length === 0) return this.$message.info('请选择至少一个会员')
            if (this.multipleSelection.length !== 1) return this.$message.info('只能选择一个会员')
            let _arr = []
            this.multipleSelection.map(item => {
                _arr.push(item.id)
            })
            this.$prompt('此操作将修改会员手机号, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^1[0-9]{10}$/,
                inputErrorMessage: '手机号格式不正确',
                type: 'warning'
            }).then(({value}) => {
                this.sureReset(_arr,'',value)
            })
        },
        async sureReset(_arr,pass,phone) {
            let _state = await updatePass(_arr.join(','),pass,phone)
            if (_state.status === 200) {
                this.$message.success('操作成功')
            } else {
                this.$message.error(_state.msg)
            }
            this.getList()
            this.multipleSelection = []
        },

        //  删除
        deleteItem() {
            if (this.multipleSelection.length === 0) return this.$message.info('请选择至少一个会员')
            let _arr = []
            this.multipleSelection.map(item => {
                _arr.push(item.id)
            })

            this.$confirm('此操作将删除选择的会员, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDel(_arr)
            })
        },
        async sureDel(_arr) {
            let _state = await delMember(_arr.join(','))
            if (_state.status === 200) {
                this.$message.success('操作成功')
            } else {
                this.$message.error(_state.msg)
            }
            this.getList()
            this.multipleSelection = []
        },
        //  证书详情
        certDetail() {
            if (this.multipleSelection.length > 1 || this.multipleSelection.length === 0) return this.$message.info('请选择一个会员操作')
            this.$router.push('/admin/memberCertificate/' + this.multipleSelection[0].id)
        },
        //  证书制作提交
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData() {
            let _state = await makeCert(
                this.multipleSelection[0].id,
                this.certForm.pay,
                this.certForm.number,
                zhDate(new Date(this.certForm.start_time)) + '~' + zhDate(new Date(this.certForm.end_time)),
                JSON.stringify(this.server)
            );
            if (_state.status === 200) {
                this.$message.success('制作成功');
                this.resetForm()
                this.getList()
            }
        },
        //  证书制作关闭
        resetForm() {
            this.server = []
            this.certForm = {
                pay: '',
                number: '',
                start_time: null,
                end_time: null,

            }
            this.$refs.certForm.clearValidate()
            this.dialog = false

        },
        //  证书制作
        certSet() {
            if (this.multipleSelection.length > 1 || this.multipleSelection.length === 0) return this.$message.info('请选择一个会员操作')
            let _arr = this.multipleSelection[0].member_type_detail_id.split(',').map(Number)
            if (this.multipleSelection[0].service2start && _arr.length === this.multipleSelection[0].service2start.length) {
                this.certForm.pay = this.multipleSelection[0].pay_style
                this.certForm.number = this.multipleSelection[0].cert_number
                this.certForm.start_time = this.multipleSelection[0].valid_time ? new Date((this.multipleSelection[0].valid_time.split('~'))[0]) : null
                this.certForm.end_time = this.multipleSelection[0].valid_time ? new Date((this.multipleSelection[0].valid_time.split('~'))[1]) : null
                this.server = this.multipleSelection[0].service2start
            } else {
                if (this.multipleSelection[0].cert_number) {
                    this.certForm.pay = this.multipleSelection[0].pay_style
                    this.certForm.number = this.multipleSelection[0].cert_number
                    this.certForm.start_time = this.multipleSelection[0].valid_time ? new Date((this.multipleSelection[0].valid_time.split('~'))[0]) : null
                    this.certForm.end_time = this.multipleSelection[0].valid_time ? new Date((this.multipleSelection[0].valid_time.split('~'))[1]) : null
                }
                let _list = this.multipleSelection[0].member_type_detail_id.split(',').map(Number)
                _list.map(item => {
                    this.server.push({
                        name: filesCN(item, this.multipleSelection[0].member_type == 1 ? supply : demand),
                        start: 'AA'
                    })
                })
            }
            this.dialog = true
        },
        //  详情
        toDetail() {
            if (this.multipleSelection.length > 1 || this.multipleSelection.length === 0) return this.$message.info('请选择一个会员操作')
            this.$router.push('/admin/memberDetail/' + this.multipleSelection[0].id)
        },
        //  缴费信息及发票管理
        toPayment() {
            if (this.multipleSelection.length > 1 || this.multipleSelection.length === 0) return this.$message.info('请选择一个会员操作')
            this.$router.push('/admin/memberPayment/' + this.multipleSelection[0].id + '/' + this.multipleSelection[0].company_name)
        },
        //  应用信息
        toCredit() {
            if (this.multipleSelection.length > 1 || this.multipleSelection.length === 0) return this.$message.info('请选择一个会员操作')
            this.$router.push('/admin/credit/' + this.multipleSelection[0].id)
        },
        //  确认不续费
        toSureNoPay() {
            if (this.multipleSelection.length > 1 || this.multipleSelection.length === 0) return this.$message.info('请选择一个会员操作')
            this.setConfirmNotRenew()
        },
        //  编辑
        toEdit() {
            if (this.multipleSelection.length > 1 || this.multipleSelection.length === 0) return this.$message.info('请选择一个会员操作')
            this.$router.push('/admin/memberEdit/' + this.multipleSelection[0].id)
        },
        //  是否确认该会员不续费
        setConfirmNotRenew() {
            if (this.multipleSelection.length === 0) return this.$message.info('请选择至少一个会员')
            this.$confirm('是否确认该会员不续费?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureConfirmNotRenew(this.multipleSelection[0].id)
            })
        },
        async sureConfirmNotRenew(id) {
            let _state = await setConfirmNotRenew(id)
            if (_state.status === 200) {
                this.$message.success('操作成功')
            }
            this.getList()
            this.multipleSelection = []
        },
        //  表格选择
        handleSelectionChange(val) {
            console.log(val)
            this.multipleSelection = val;
        },
        //  重置
        reset() {
            this.name = ''
            this.code = ''
            this.certificate = ''
            this.search_dengji = ''
            this.apply = 0
            this.level = 0
            this.pay = 0
            this.memberType = 0
            this.moreType = []
            this.levely = 0
            this.address = '全部'
            this.registerAddress = ''
            this.mailAddressDetail = ''
            this.endTime = null
            this.page = 1
            this.getList()
            this.exportUrl = this.udhost + '/api/index/companyDataExport'
        },
        //  搜索
        search() {
            this.page = 1
            this.getList()
            this.exportUrl = this.udhost + '/api/index/companyDataExport?search_company_name=' + this.name +
                '&search_company_code=' + this.code +
                '&search_cert_number=' + this.certificate +
                '&search_dengji=' + this.search_dengji +
                '&search_state=' + this.apply +
                '&search_member_type=' + this.memberType +
                '&search_member_type_id=' + this.moreType.join(',') +
                '&search_company_level_id=' + this.level +
                '&search_post_address_county=' + (this.address === '全部' ? '' : this.address) +
                '&search_register_address_county=' + this.registerAddress +
                '&search_post_address_detail=' + this.mailAddressDetail +
                '&search_valid_time=' + (this.endTime && this.endTime.length > 0 ? zhDate(new Date(this.endTime[0])) + '~' + zhDate(new Date(this.endTime[1])) : '') +
                '&search_is_pay=' + this.pay
        },
        //  获取列表
        async getList() {
            let _list = await userQuery(this.user.user_id,
                this.page, this.limit,
                this.name,
                this.code,
                this.certificate,
                this.search_dengji,
                this.apply,
                this.memberType,
                this.moreType.join(','),
                this.level,
                this.address === '全部' ? '' : this.address,
                this.registerAddress,
                this.mailAddressDetail,
                this.endTime && this.endTime.length > 0 ? zhDate(new Date(this.endTime[0])) + '~' + zhDate(new Date(this.endTime[1])) : '',
                this.pay
            )
            this.tableData = _list.data
            this.total = _list.total
        },
    },
    filters: {
        type(val) {
            return filesCN(Number(val), nature)
        },
        level(val) {
            return filesCN(Number(val), level)
        }
    },
    watch: {
        memberType(){
            this.moreType = []
        }
    },
}
</script>

<style lang="scss" scoped>
.member {
    background: #fff;
    padding: 30px;
    border-radius: 8px;

    .search-some {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
            display: block;
            width: 80px;
        }

        .el-input {
            flex: 1;
        }

        .el-select {
            flex: 1;
        }
    }
    .del{
        color: #e4393c;
        text-decoration: line-through;
    }
}
</style>